import { Box, Container, Stack, Typography } from "@mui/material";

function About() {
  return (
    <Box sx={{ backgroundColor: "rgb(255, 255, 255);" }}>
      <Container sx={{ py: 4 }}>
        <Stack spacing={2} useFlexGap >
          <Typography variant="h4" component="h2">Om oss</Typography>
          <Typography>Det här är vi!</Typography>
          <Typography>Vi, Peter & Jenny, och våra tre barn bor i Dannike. Mitt ute på landet - vilket vi älskar!</Typography>
          <Typography>Jenny driver en liten Swish & Grab butik på gården där man kan köpa presenter, inredning, te mm.</Typography>
          <Typography>Det var där tanken om Lokala Pärlor föddes. Att det skulle vara enkelt att hitta till den lilla på butiken på ett smidigt sätt. Så varför inte skapa en app för hela landet, så både turister och närboende hittar det dom söker.</Typography>
          <Typography>Jenny har arbetat inom serviceyrken i över 25 år, främst inom restaurang, konferens, bröllop med ledande roller. Peter har en bartenderutbildning och har även arbetat inom service, Peter är dessutom duktig fotograf.</Typography>
          <Typography>Tillsammans har vi över 30 års erfarenhet inom just service. Vi har dessutom ett brinnande intresse för mat & smaker.</Typography>
        </Stack>
      </Container>
    </Box>
  )
}

export default About;